import React from 'react';

export type SelectOptionProps = React.OptionHTMLAttributes<HTMLOptionElement>;

const SelectOption: React.FC<SelectOptionProps> = props => {
  const { children, /* className, */ ...restProps } = props;

  return <option {...restProps}>{children}</option>;
};

export default SelectOption;
